
import axios from "axios";
import { LIVE_API_BASE_URL, TEST_API_BASE_URL, UAT_API_BASE_URL } from "configs/EnvironmentConfig";

const seoService = {};
// const apiRoute = `${process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'https://sabineapi.riolabz.com/api/v1'}/pages-seo`;
const apiRoute = process.env.REACT_APP_API_STAGE == "Live" ? `${LIVE_API_BASE_URL}pages-seo` : process.env.REACT_APP_API_STAGE == "Uat" ? `${UAT_API_BASE_URL}pages-seo` : `${TEST_API_BASE_URL}pages-seo`;

// Create an axios instance (optional but recommended)
const axiosInstance = axios.create({
    baseURL: apiRoute,
    headers: {
        "Content-Type": "application/json",
    },
});

seoService.get = async function (path) {
    try {
        const res = await axiosInstance.get(`/url/${encodeURIComponent(path)}`);
        return res.data; // Return response data 
    } catch (err) {
        console.error("Error fetching SEO data:", err);
        throw err; // Re-throw to handle errors at the caller level
    }
};

// const seoService = {}
// const apiRoute = '/pages-seo';



// seoService.get = async function (path) {
//     try {
//         const res = await fetch({
//             url: `${apiRoute}/url/${encodeURIComponent(path)}`,
//             method: 'get',
//         })
//         return res
//     } catch (err) {
//         console.log(err, 'show-err')
//     }
// }



export default seoService;